import { Center, Spinner } from '@chakra-ui/react';
import React from 'react';

function FullPageSpinner() {
  return (
    <Center height="100vh">
      <Spinner colorScheme="green" />
    </Center>
  );
}

export default FullPageSpinner;
